






























import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import moduleStore from '../store/migu';
import to from 'await-to-js';

@Component({})
@moduleStore.initVuex({
  mutationNames: moduleStore.mutationNames,
  actionNames: moduleStore.actionNames,
})
export default class StepText extends Vue {

  @Prop({default: true})
  visible: boolean;

  show = false;
  activeMoodId = 'HAPPY';
  moodList = [
    { id: 'HAPPY', name: '😄开心'},
    { id: 'SAD', name: '😢悲伤'},
    { id: 'ANGER', name: '😡愤怒'},
    { id: 'AMAZED', name: '😮惊讶'},
    { id: 'FEAR', name: '😱恐惧'},
    { id: 'CONFUSION', name: '😖困惑'},
  ];

  @Watch('visible')
  listenVisible(val) {
    this.show = val
    if (val) {
      // 不保留上次心情选项，恢复默认初始状态
      this.activeMoodId = 'HAPPY';
    }
  }
  // 关闭弹窗
  closePopup() {
    this.show = false;
    this.$emit('close');
  }

  // 选中心情
  doCheckMood(item) {
    this.activeMoodId = item.id;
  }

  // 生成文案
  async doSetText() {
    const text = await this.getMoodText();
    this.$emit('set-text', text);
    this.closePopup();
  }

  // 随机心情文案
  async getMoodText() {
    const [err, res] = await to(this.$http('getRandomText', { typeEnum: this.activeMoodId }));
    if (err || res.code !== 200 || !res.data) {
      return '';
    }
    return res.data[0];
  }

}
